export class TableDataCellState {
	invalid = false;
}
